import moment from "moment-business-days";

const VueMomentBusinessDays = {
  install: function (Vue) {
    Vue.mm = moment;
    Vue.prototype.$mm = moment;
    Vue.setMomentHolidays = setMomentHolidays;
  }
};

function setMomentHolidays(holidays) {
  if (holidays && holidays.length) {
    // console.log('setMomentHolidays', holidays);
    var locale = 'en';
    var hld = holidays.map( (e)=> {
      return moment(e).format('YYYY-MM-DD');
    });
    moment.updateLocale(locale, {
      holidays: hld,
      holidayFormat: 'YYYY-MM-DD',
      workingWeekdays: [1, 2, 3, 4, 5]
    });
    moment.locale(locale);
  }
}

export default VueMomentBusinessDays;